import { useCallback, useRef } from 'react';
import { useServerLayoutEffect } from './use-server-layout-effect.js';

/** A version of `useEffectEvent` that runs synchronously during SSR. */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function useServerEffectEvent<T extends Function>(fn?: T): T {
  const ref = useRef<T | null | undefined>(null);

  useServerLayoutEffect(() => {
    ref.current = fn;
  }, [fn]);

  // @ts-expect-error `args` rest parameter doesn't play well with the `Function` type
  return useCallback<T>((...args) => {
    const f = ref.current!;
    return f?.(...args);
  }, []);
}
